import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/organization';

const options = {
  cache: {
      maxAge: 60 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadOrganizations = async ({ organization_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { organization_ids });
  return api.get(url, options);
}

export {
  loadOrganizations,
}
